export const getMultiLegOrderLabel = (
  orderClass: unknown,
  legs: unknown,
  isNestedRow: boolean,
): string | null => {
  if (
    isNestedRow ||
    orderClass !== "mleg" ||
    !Array.isArray(legs) ||
    legs.length === 0
  ) {
    return null;
  }

  return `${legs.length}-Leg Order`;
};
